import { RootState } from '@/store'
import { BaseQueryApi } from '@reduxjs/toolkit/dist/query/baseQueryTypes'

export default function setAuthorization(
	headers: Headers,
	{
		getState,
		endpoint: endpointName,
		blockedEndpoints,
	}: Pick<BaseQueryApi, 'getState' | 'endpoint'> & {
		blockedEndpoints?: Array<string>
	}
) {
	if (blockedEndpoints && blockedEndpoints.includes(endpointName)) {
		return headers
	}

	const { token } = (getState() as RootState).auth

	if (token) {
		headers.set('authorization', `Bearer ${token}`)
	} else {
		headers.delete('authorization')
	}

	return headers
}
